export function SortingListIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='18' height='16' viewBox='0 0 18 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M1.5 1.33333H12.3333M1.5 4.66666H9M1.5 7.99999H9M13.1667 4.66666V14.6667M13.1667 14.6667L9.83333 11.3333M13.1667 14.6667L16.5 11.3333'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
